import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Chip, Button, Alert } from '@mui/material';
import api from '../../services/api';

interface AnalysisItem {
  _id: string;
  name: string;
  analysisType: string;
  status: string;
  createdAt: string;
}

const DelayAnalysisList: React.FC = () => {
  const [items, setItems] = useState<AnalysisItem[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await api.get('/ai-analysis', { params: { analysisType: 'risk_assessment', limit: 50 } });
        const data = res.data?.data || res.data || [];
        setItems(data);
      } catch (err: any) {
        setError(err.response?.data?.message || err.message || 'Failed to load history');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Delay Analysis History</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}
      {items.map(item => (
        <Card key={item._id} sx={{ mb: 2 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="h6">{item.name}</Typography>
                <Typography variant="body2" color="text.secondary">{new Date(item.createdAt).toLocaleString()}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Chip label={item.status} color={item.status === 'completed' ? 'success' : item.status === 'failed' ? 'error' : 'default'} />
                <Button variant="outlined" onClick={() => window.location.href = `/ai-endpoints/delay-analysis/${item._id}`}>View Details</Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
      {!loading && items.length === 0 && (
        <Typography variant="body2" color="text.secondary">No analyses yet.</Typography>
      )}
    </Box>
  );
};

export default DelayAnalysisList;